import { createStore, applyMiddleware } from 'redux';
import { userFormReducer } from './Reducers/userFormReducer';
import { errorAndLoadingReducer } from './Reducers/errorAndLoadingReducer';
import { userReducer } from './Reducers/userReducer';
import { patientDetailsFormReducer, patientsReducer, 
         getPatientDetailsReducer, getPerformaOneReducer,
         getDisorderAndTreatmentReducer, getScansReducer,
         getXrayReducer, getClinicalFeatureReducer,
         dexaReducer, investigationReducer, dexa1Reducer, dexa3Reducer,getHrpqctReducer} from './Reducers/patientReducer';
import { combineReducers } from 'redux';
import reduxThunk from 'redux-thunk';

const store = createStore(combineReducers({
    userForm: userFormReducer,
    loadingAndError: errorAndLoadingReducer,
    user: userReducer,
    patientDetailsForm: patientDetailsFormReducer,
    patientsDetails: patientsReducer,
    getPatientDetails: getPatientDetailsReducer,
    getPerformaOne: getPerformaOneReducer,
    getScans: getScansReducer,
    getXray: getXrayReducer,
    getDisorderAndTreatment: getDisorderAndTreatmentReducer,
    getClinicalFeature: getClinicalFeatureReducer,
    getDexa: dexaReducer,
    getDexa1: dexa1Reducer,
    getDexa3: dexa3Reducer,
    getInvestigation: investigationReducer,
    getHrpqctReducer: getHrpqctReducer,
    
}), applyMiddleware(reduxThunk));

export default store;